import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { performanceMonitor } from './utils/performanceMonitoring';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// All performance monitoring temporarily disabled
console.log('🔍 All performance monitoring temporarily disabled');

// reportWebVitals();
// reportWebVitals(metric => {
//   console.log(`📊 ${metric.name}: ${metric.value}`, metric);
// });
